import ReactDOM from 'react-dom/client';
import './Global.css';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import store, { persistor } from "./redux/store";
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './Navigation';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { ToastProvider } from 'react-toast-notifications';
import './scss/core.scss'
import './scss2/style.scss'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PersistGate persistor={persistor}>
      <Provider store={store}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </Provider>
    </PersistGate>
);
reportWebVitals();
